<template>
  <q-table flat bordered :data="invoicesPayments" :columns="columns" row-key="id" :pagination.sync="pagination">
    <template v-slot:bottom>
      <!-- <pagination-table
              @change="getStatementsAdmin"
              :data="reqPagination"
              :pagination="pagination"
            /> -->
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        <div class="row items-center">
          <span class="q-mr-md">{{$t('rows_per_page')}}</span>
            <q-select
            v-model="pagination.rowsPerPage"
            :options="[10, 20, 50, 100]"
            dense
            @input="onRowsPerPageChange"
            style="max-width: 60px; padding-left: 8px; padding-right: 8px"
            />
           <span>Total: {{ reqPagination.total }}</span>
        </div>
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
    <template v-slot:top-right>
      <q-btn
        outline
        :label="$t('export_csv')"
        color="grey-3"
        size="12px"
        text-color="grey-8"
        icon-right="archive"
        class="q-mr-sm q-py-xs"
        no-caps
        @click="exportClickReport()"
        unelevated
      >
      </q-btn>
      <AdminExtract :filters="filterInvoicesPayments" />
    </template>
  </q-table>
</template>

<script>
import FinancialMixin from '../../mixins/FinancialMixin';
import AdminExtract from './AdminExtract';

export default {
  name: 'ListApproveInvoices',
  components: { AdminExtract },
  mixins: [FinancialMixin],

  data() {
    return {
      params: {
        payout: null,
        paymentDay: null
      },
      columns: [
        {
          name: 'affilate_id',
          required: true,
          label: this.$t('affiliate_id'),
          align: 'left',
          field: 'affiliate_id',
          sortable: true
        },
        {
          name: 'affiliate_idv2',
          required: true,
          label: 'ID v2',
          align: 'left',
          field: 'affiliate_idv2',
          sortable: true
        },
        {
          name: 'affilate',
          required: true,
          label: this.$t('affiliate'),
          align: 'left',
          field: 'affiliate_name',
          sortable: true
        },
        {
          name: 'campaign_id',
          required: true,
          label: this.$t('campaign_id'),
          align: 'left',
          field: 'campaign_id',
          sortable: true
        },
        {
          name: 'date',
          required: true,
          label: this.$t('month_year_reference'),
          align: 'left',
          field: 'date',
          sortable: true
        },
        {
          name: 'campaign_name',
          required: true,
          label: this.$t('campaign'),
          align: 'left',
          field: 'campaign_name',
          sortable: true
        },
        {
          name: 'value',
          required: true,
          label: this.$t('invoice_amount'),
          align: 'left',
          field: 'value',
          sortable: true
        },
        {
          name: 'state_id',
          required: true,
          label: 'Status',
          field: 'state_id',
          format: (state_id) => this.formatStates(state_id),
          align: 'center'
        }
      ],
      pagination: {
        sortBy: 'trademark',
        descending: true,
        rowsPerPage: parseInt(localStorage.getItem('rowsPerPage')) || 10
      }
    };
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getStatementsAdmin(
          this.filterInvoicesPayments.dateFrom,
          this.filterInvoicesPayments.dateTo,
          this.filterInvoicesPayments.affiliateId,
          this.filterInvoicesPayments.state_id,
          this.currentPage,
          this.pagination.rowsPerPage
        );
      }
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  methods: {
    formatPaymentDate(date) {
      if (date == null) return 'Sem data definida';
      return (val) => this.$moment(val).format('L');
    },
    async exportClickReport() {
      this.onLoading(true);

      let statementsCsv = await this.getStatementsAdminCsv(
        this.filterInvoicesPayments.dateFrom,
        this.filterInvoicesPayments.dateTo,
        this.filterInvoicesPayments.affiliateId,
        this.filterInvoicesPayments.state_id
      );

      this.exportTableCsv(statementsCsv, this.columns, `admin_extrato_bancario_/`);

      this.onLoading(false);
    },
    formatStates(state) {
      switch (state) {
        case 1:
          return this.$t('pending_release');

        case 2:
          return this.$t('liberated');

        case 3:
          return this.$t('requested');

        case 4:
          return this.$t('approved');

        case 5:
          return this.$t('paid');

        case 11:
          return this.$t('refused');

        case 12:
          // return 'Pré-Aprovado';
          return this.$t('requested');

        default:
          return '-';
      }
    },
    onRowsPerPageChange(value) {
      this.pagination.rowsPerPage = value;
      localStorage.setItem('rowsPerPage', value);
      this.getStatementsAdmin(
        this.filterInvoicesPayments.dateFrom,
        this.filterInvoicesPayments.dateTo,
        this.filterInvoicesPayments.affiliateId,
        this.filterInvoicesPayments.state_id,
        this.currentPage,
        value
      );
    },
  }
};
</script>
